import { render, staticRenderFns } from "./orally_speaking_header.vue?vue&type=template&id=e9510434&scoped=true"
import script from "./orally_speaking_header.vue?vue&type=script&lang=js"
export * from "./orally_speaking_header.vue?vue&type=script&lang=js"
import style0 from "./orally_speaking_header.vue?vue&type=style&index=0&id=e9510434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9510434",
  null
  
)

export default component.exports